import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import {
    Button,
    Card,
    Col,
    Dropdown,
    Input,
    Menu, Modal,
    Row, Spin,
    Table,
    Tag,
    Divider,
    Select
} from "antd";
import { Calendar } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import useOnBlur from "../../../util/useOnBlue";
import { get, post, responseValidator, SITEURL } from "../../../api";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import { toast } from "react-toastify";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import Loading from "../../../loading/loading.index";

export default function OrderHistry(props) {
    const [isCalender, setIsCalender] = useState(false);
    const [birthInputShow, setBirthInputShow] = useState();
    const isCalenderRef = useRef();
    const [selectedDay, setSelectedDay] = useState(null);
    const [birth, setBirth] = useState(null);
    const [isCalender2, setIsCalender2] = useState(false);
    const [birthInputShow2, setBirthInputShow2] = useState();
    const isCalenderRef2 = useRef();
    const [selectedDay2, setSelectedDay2] = useState(null);
    const [birth2, setBirth2] = useState(null);
    const [status, setStatus] = useState( "انتخاب نشده" );
    const { Option } = Select;
    const [loading, setLoading] = useState(true);
    const allData = [];
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [orders, setOrders] = useState(undefined);
    const searchInput = useRef();
    const paramsRef = useRef({});
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [dataSelected, setDataSelected] = useState(null)
    const [modalLoading, setModalLoading] = useState(true)
    const [modalType, setModalType] = useState(null)
    const [orderStatus, setOrderStatus] = useState(null)
    const [submitLoading, setSubmitLoading] = useState(false);
    const [trackingCode, setTrackingCode] = useState(null)
    paramsRef.current.pageIndex = 1;
    paramsRef.current.pageCount = 100000000;

    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText("");
    };

    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={` جستجو ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <div>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        پاک کردن
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        فیلتر
                    </Button>
                </div>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined
                style={{ color: filtered ? "#1890ff" : undefined }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            )
    });

    function getData() {
        setLoading(true);
        get(props.isAdmin ? "/Order/" : "/Order/Mine/", paramsRef.current).then(
            response => {
                setLoading(false);
                if (responseValidator(response.status)) {
                    response.data.data.map((item, index) => {
                        allData.push({
                            key: index,
                            id: item.trackingCode,
                            market: item.market,
                            sourceAmount: item.sourceAmount,
                            destinationAmount: item.destinationAmount,
                            time: item.dateTime,
                            sourceType: item.sourceType.id,
                            destinationType: item.destinationType.id,
                            state: item.state,
                            fullName: item.userFullName
                        });
                    });
                    console.log(allData);
                    setOrders(allData);
                } else {
                    toast.error(response.data.message);
                    if (response.status === 403)
                        setTimeout(() => {
                            window.location.replace("/authorization/");
                        }, 3000);
                }
            }
        );
    }

    useEffect(() => {
        getData();
    }, []);

    function submitHandler() {
        setSubmitLoading(true)
        post('/order/ChangeOrderStatus', {
            'trackingCode': trackingCode,
            'State': parseInt( orderStatus)
        }).then(res => {
            setSubmitLoading(false);
            if (responseValidator(res.status)) {
                toast.success(res.data.message);
                setIsModalOpen(false)
                setModalLoading(false)

            } else
                toast.error(res.data.message);
        })
        setSubmitLoading(false)

    }
    function actionHandler(item, type) {
        setModalType(type)
        setIsModalOpen(true)
        if (type === 'view') {
            get('/Order/ViewDetails/' + item.id).then(res => {

                if (responseValidator(res.status)) {
                    setDataSelected(res.data.data)
                    setModalLoading(false)
                } else toast.error(res.data.message)
            })
        }
        else {
            setModalLoading(false)
            setTrackingCode(item.id)
        }

    }

    const columns = [
        {
            title: "شناسه",
            dataIndex: "id",
            key: "id",
            render: text => <span className="gx-link">{text}</span>,
            ...getColumnSearchProps("id")
        },
       /* {
            title: "کاربر",
            dataIndex: "fullName",
            key: "fullName",
            render: text => <span className="gx-link">{text}</span>,
            ...getColumnSearchProps("fullName")
        },*/
        {
            title: "جفت ارز",
            dataIndex: "market",
            key: "market",
            render: text => <span className="gx-link">{text}</span>,
            ...getColumnSearchProps("market")
        },
        {
            title: "مبلغ مبدا",
            dataIndex: "sourceAmount",
            key: "sourceAmount",
            render: text => <span>{text}</span>,
            sorter: (a, b) => a.sourceAmount - b.sourceAmount
        },
        {
            title: "مبلغ مقصد",
            dataIndex: "destinationAmount",
            key: "destinationAmount",
            render: text => <span>{text}</span>,
            sorter: (a, b) => a.destinationAmount - b.destinationAmount
        },
        {
            title: "تاریخ",
            dataIndex: "time",
            key: "time",
            sorter: (a, b) =>
                moment(new Date(a.time)).unix() -
                moment(new Date(b.time)).unix(),
            render: date => (
                <>
                    <span>
                        {date.split(":")[0].slice(11, 13) +
                            ":" +
                            date.split(":")[1] +
                            " - " +
                            new Date(date).toLocaleDateString("fa-IR")}
                    </span>
                </>
            )
        },
        {
            title: "وضعیت",
            dataIndex: "state",
            key: "state",
            render: tag => (
                <>
                    <Tag
                        color={
                            tag === "موفق / موفق"
                                ? "green"
                                : tag === "ناموفق"
                                    ? "red"
                                    : tag.includes("در حال انجام")
                                        ? "blue"
                                        : "orange"
                        }
                        key={tag}
                    >
                        {tag}
                    </Tag>
                </>
            ),
            filters: [
                { text: "موفق", value: "موفق" },
                { text: "نا موفق", value: "نا موفق" },
                { text: "ساخته شده", value: "ساخته شده" },
                { text: "در حال انجام", value: "در حال انجام" }
            ],
            onFilter: (value, record) => record.state.includes(value)===true

        },
        {
            title: "عمیات",
            key: "action",
            render: text => (
                <span>
                    <span
                        onClick={() => actionHandler(text, 'view')}
                        className="gx-link"
                    >
                        نمایش جزئیات
                    </span>
                    <Divider type="vertical" />

                    {props.isAdmin ?
                        <span onClick={() => actionHandler(text, 'edit')}
                            className="gx-link">
                            ویرایش
                        </span> : ""}
                </span>
            )
        }
    ];

    function datePickerHandler(e) {
        setSelectedDay(e);
        console.log(e);
        setBirthInputShow(e.year + "/" + e.month + "/" + e.day);
        let date = moment
            .from(e.year + "/" + e.month + "/" + e.day, "fa", "YYYY/MM/DD")
            .format("YYYY/MM/DD");
        console.log(date);
        date = new Date(date);
        console.log(date);
        date = date.toISOString();
        console.log(date);
        setBirth(date);
        setIsCalender(false);
    }

    function datePickerHandler2(e) {
        setSelectedDay2(e);
        console.log(e);
        setBirthInputShow2(e.year + "/" + e.month + "/" + e.day);
        let date = moment
            .from(e.year + "/" + e.month + "/" + e.day, "fa", "YYYY/MM/DD")
            .format("YYYY/MM/DD");
        console.log(date);
        date = new Date(date);
        console.log(date);
        date = date.toISOString();
        console.log(date);
        setBirth2(date);
        setIsCalender2(false);
    }

    useOnBlur(isCalenderRef, () => {
        if (isCalender) setIsCalender(false);
    });

    useOnBlur(isCalenderRef2, () => {
        if (isCalender2) setIsCalender2(false);
    });

    function resetFilterHandler() {
        setSelectedDay(null);
        setBirthInputShow(null);
        setBirth(null);
        setSelectedDay2(null);
        setBirthInputShow2(null);
        setBirth2(null);
        setStatus("انتخاب نشده" );
        delete paramsRef.current.State;
        delete paramsRef.current.FromDate;
        delete paramsRef.current.ToDate;
        getData();
    }

    function filterHandler() {
        if (status.id !== 0) paramsRef.current.State = status.id;
        else delete paramsRef.current.State;

        if (birth) paramsRef.current.FromDate = birth;

        if (birth2) paramsRef.current.ToDate = birth2;

        getData();
    }

    if (loading) return <Loading />;

    return (
        <Card className="temx-order-history-page" title="تاریخچه سفارشات">
            <Modal footer={[
                <Button key="back" onClick={() => {
                    setIsModalOpen(false)
                    setModalLoading(true)
                    setDataSelected(null)
                }}>
                    بستن
                </Button>,
            ]} closable={false} closeIcon={false} className='order-detail-modal'
                title={!modalLoading && <div className='title'>
                    {modalType === 'view' ? <p>جزئیات سفارش</p> : <p>ویرایش سفارش</p>}
                    <span className='spacer' />
                    {modalType === 'view' ? <Tag
                        color={
                            dataSelected.state === 'موفق / موفق'
                                ? "green"
                                : dataSelected.state === "ناموفق"
                                    ? "red"
                                    : dataSelected.state.includes("در حال انجام")
                                        ? "blue"
                                        : "orange"
                        }
                    >
                        {dataSelected.state}
                    </Tag> : ''}


                </div>}
                confirmLoading={modalLoading} visible={isModalOpen} onCancel={() => {
                    setIsModalOpen(false)
                    setModalLoading(true)
                    setDataSelected(null)
                }}>
                {!modalLoading ?
                    modalType === 'view' ?
                        <div className='temx-order-detail-page'>

                            <div className='items'>
                                <p>ارز : {dataSelected.destinationMarket} <i
                                    className="fas fa-arrow-left" /> {dataSelected.sourceMarket}</p>
                                <span className='spacer' />

                            </div>
                            <div className='items'>
                                <p>شناسه : </p>
                                {dataSelected.trackingCode ? <h6>{dataSelected.trackingCode}</h6>
                                    : <h6>نامشخص</h6>} </div>

                            <div className='items'>
                                <p>تاریخ : </p>
                                {dataSelected.date ? <h6>{new Date(dataSelected.date).toLocaleDateString('fa')}</h6>
                                    : <h6>نامشخص</h6>}  </div>
                            <div className='items'>
                                <p>کاربر : </p>
                                {dataSelected.fullName ? <h6>{dataSelected.fullName}</h6>
                                    : <h6>نامشخص</h6>} </div>
                            <div className='items'>
                                <p>مقدار مبدا : </p>
                                {dataSelected.sendAmount ? <h6>{dataSelected.sendAmount}</h6>
                                    : <h6>نامشخص</h6>}     </div>

                            <div className='items'>
                                <p>مقدار مقصد : </p>
                                {dataSelected.receivedAmount ? <h6>{dataSelected.receivedAmount}</h6>
                                    : <h6>نامشخص</h6>} </div>

                            <div className='items'>
                                <p>مقدار دریافتی در کیف پول مقصد : </p>
                                {dataSelected.receivedAmountAfterCommission ?
                                    <h6>{dataSelected.receivedAmountAfterCommission}</h6>
                                    : <h6>نامشخص</h6>}   </div>

                            <div className='items'>
                                <p> آدرس دریافت کننده : </p>
                                {dataSelected.destinationWallet ? <h6>{dataSelected.destinationWallet}</h6>
                                    : <h6>نامشخص</h6>}  </div>

                            <div className='items'>
                                <p style={{ display: 'flex', flexDirection: 'row-reverse' }}>txid برداشت : </p>
                                {dataSelected.destinationTxid ?
                                    <React.Fragment>
                                        <i style={{ cursor: 'pointer', marginRight: '4px' }} onClick={() => {
                                            navigator.clipboard.writeText(
                                                dataSelected.destinationTxid
                                            );
                                            toast.success("کپی شد");
                                        }} className="far fa-copy" />

                                        <h6 style={{ maxWidth: '300px' }}>{dataSelected.destinationTxid}</h6>
                                    </React.Fragment>
                                    : <h6>نامشخص</h6>
                                }   </div>


                            <div className='items'>
                                <p>قیمت ریالی ارز مقصد : </p>
                                {dataSelected.marketIrtPrice ? <h6>{dataSelected.marketIrtPrice}</h6>
                                    : <h6>نامشخص</h6>}     </div>

                            {dataSelected.destinationMarket != "IRT" && dataSelected.network ? <div className='items'>
                                <p>شبکه انتقال :</p>
                                <h6>{dataSelected.network ? dataSelected.network : "نامشخص"}</h6>
                            </div> : ""}



                            {dataSelected.fee ? <div className='items'>
                                <p>کارمزد شبکه :</p>
                                <h6>{dataSelected.fee ? dataSelected.fee : "نامشخص"}</h6>
                            </div> : ""}

                            {dataSelected.voucherCode ? <div className='items'><p>کد ووچر :</p><h6>{dataSelected.voucherCode}</h6></div> : ""}
                            {dataSelected.voucherActivation ? <div className='items'><p>کد فعالساز ووچر :</p><h6>{dataSelected.voucherActivation}</h6></div> : ""}

                        </div>

                        :
                        modalType === 'edit' ?
                            <div className='temx-order-editStatus'>
                                <div className="my-row">
                                    <div className="items">
                                        <label>وضعیت سفارش*</label>
                                        <Select placeholder='وضعیت سفارش را انتخاب کنید :' onChange={e => setOrderStatus(e)}>
                                            <Option value='3'>موفق</Option>
                                            <Option value='5'>در انتظار واریز دستی</Option>
                                            <Option value='4'>ناموفق</Option>
                                        </Select>

                                    </div>
                                    <div className="my-btn">
                                        <Button
                                            className="my-real-btn"
                                            disabled={!orderStatus}
                                            onClick={submitHandler}
                                            type={"primary"}
                                            loading={submitLoading}
                                        >
                                            تغییر وضعیت سفارش
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            :
                            ''
                    : <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <Spin />
                    </div>}

            </Modal>
            <div className="filter">
                <div className="items">
                    <h4>تاریخ شروع</h4>
                    <div className="birth">
                        <Input
                            onClick={() => setIsCalender(true)}
                            value={birthInputShow}
                            readOnly={true}
                            placeholder="تاریخ شروع"
                        />
                        <i
                            onClick={() => setIsCalender(!isCalender)}
                            className="icon icon-calendar"
                        />
                        <div
                            ref={isCalenderRef}
                            className={`my-calender ${isCalender ? "active" : ""
                                }`}
                        >
                            <Calendar
                                colorPrimary={"#157DE1"}
                                value={selectedDay}
                                locale="fa"
                                onChange={datePickerHandler}
                                shouldHighlightWeekends
                            />
                        </div>
                    </div>
                </div>

                <div className="items">
                    <h4>تاریخ پایان</h4>
                    <div className="birth">
                        <Input
                            onClick={() => setIsCalender2(true)}
                            value={birthInputShow2}
                            readOnly={true}
                            placeholder="تاریخ پایان"
                        />
                        <i
                            onClick={() => setIsCalender2(!isCalender2)}
                            className="icon icon-calendar"
                        />
                        <div
                            ref={isCalenderRef2}
                            className={`my-calender ${isCalender2 ? "active" : ""
                                }`}
                        >
                            <Calendar
                                colorPrimary={"#157DE1"}
                                value={selectedDay2}
                                locale="fa"
                                onChange={datePickerHandler2}
                                shouldHighlightWeekends
                            />
                        </div>
                    </div>
                </div>

                <div style={{ width: "fit-content" }} className="items">
                    <h4>وضعیت</h4>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item
                                    onClick={() =>
                                        setStatus( "ساخته شده" )
                                    }
                                >
                                    <h4 style={{ color: "#656565" }}>
                                        ساخته شده
                                    </h4>
                                </Menu.Item>

                                <Menu.Item
                                    onClick={() =>
                                        setStatus(
                                        "در حال انجام"
                                        )
                                    }
                                >
                                    <h4 style={{ color: "#656565" }}>
                                        درحال انجام
                                    </h4>
                                </Menu.Item>

                                <Menu.Item
                                    onClick={() =>
                                        setStatus("موفق" )
                                    }
                                >
                                    <h4 style={{ color: "#656565" }}>موفق</h4>
                                </Menu.Item>

                                <Menu.Item
                                    onClick={() =>
                                        setStatus( "ناموفق" )
                                    }
                                >
                                    <h4 style={{ color: "#656565" }}>ناموفق</h4>
                                </Menu.Item>

                                <Menu.Item
                                    onClick={() =>
                                        setStatus("انتخاب نشده"
                                        )
                                    }
                                >
                                    <h4 style={{ color: "#656565" }}>
                                        انتخاب نشده
                                    </h4>
                                </Menu.Item>
                            </Menu>
                        }
                        trigger={["click"]}
                    >
                        <div className="one-card-drop-down-selected status-selected">
                            <h4>{status}</h4>
                            <DownOutlined />
                        </div>
                    </Dropdown>
                </div>
                <div className="my-btn">
                    <Button onClick={resetFilterHandler} type={"ghost"}>
                        بازیابی
                    </Button>
                </div>
                <div className="my-btn">
                    <Button onClick={filterHandler} type={"primary"}>
                        جستجو
                    </Button>
                </div>
            </div>
            <Row className="order-table">
                <Col span={24}>
                    {orders && (
                        <Card>
                            <Table
                                loading={loading}
                                pagination={{ pageSize: 10 }}
                                bordered={true}
                                className="gx-table-responsive"
                                columns={columns}
                                dataSource={orders}
                            />
                        </Card>
                    )}
                </Col>
            </Row>
        </Card>
    );
}
